import React from 'react';
import styles from './Input.module.css';

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = { focused: false };
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur  = this.handleBlur.bind(this);
  }

  handleFocus() { this.setState({ focused: true }); }
  handleBlur()  { this.setState({ focused: false }); }

  render() {
    const {
      label, hint, error, required, counter,
      prefix, suffix, type = 'text',
      value, onChange, placeholder, maxLength, disabled,
      style,
    } = this.props;

    const { focused } = this.state;
    const wrapCls = [
      styles.fieldWrap,
      focused ? styles.focused : '',
      error   ? styles.error   : '',
    ].filter(Boolean).join(' ');

    return (
      <div className={styles.wrap} style={style}>
        {label && (
          <label className={styles.label}>
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <div className={wrapCls}>
          {prefix && <span className={styles.prefix}>{prefix}</span>}
          <input
            className={styles.input}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
          />
          {suffix && <span className={styles.suffix}>{suffix}</span>}
        </div>
        {counter && maxLength && (
          <div className={styles.counter}>
            {(value || '').length} / {maxLength}
          </div>
        )}
        {hint  && !error && <div className={styles.hint}>{hint}</div>}
        {error && <div className={styles.err}>{error}</div>}
      </div>
    );
  }
}

export default Input;
